/* esm.sh - @radix-ui/react-use-layout-effect@1.1.1 */
import*as t from"react";var e=globalThis?.document?t.useLayoutEffect:()=>{};export{e as useLayoutEffect};
//# sourceMappingURL=react-use-layout-effect.mjs.map